"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
exports.default = () => styles_1.createStyles({
    root: {
        marginTop: '.25em'
    },
    hint: {
        fontSize: '.75em'
    }
});
//# sourceMappingURL=styles.js.map